/**
 * kult-details.js — Details-Toggle (snippets/kult-details.liquid), 10.10.2026.
 * Event-Delegation auf document: funktioniert auch nach Section-Rendering (Warenkorb-Drawer) und in JS-gefüllten
 * Bereichen (Club-Rechner, Konfiguratoren). Schaltet aria-expanded, hidden am Panel und .is-open am Wrapper.
 * Escape im aufgeklappten Panel klappt zu und setzt den Fokus zurück auf den Button.
 */
(function () {
  if (window.kultDetailsReady) return;
  window.kultDetailsReady = true;

  function set(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var wrap = btn.closest('[data-kult-details]');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    if (wrap) wrap.classList.toggle('is-open', open);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kult-details-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    set(btn, btn.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wrap = e.target.closest ? e.target.closest('[data-kult-details].is-open') : null;
    if (!wrap) return;
    var btn = wrap.querySelector('[data-kult-details-toggle]');
    if (!btn || e.target === btn) return;
    set(btn, false);
    btn.focus();
  });
})();
